<section
  class="section picton-100 sub-product-white-paper"
  *ngIf="_whitePaperData"
>
  <div class="section-container-inside">
    <div class="section-whitepapers section-whitepapers-reverse">
      <div class="display-f align-c-e">
        <img
          class="img-align-b wid-full"
          loading="lazy"
          src="{{
            _whitePaperData?.whitepapersAndReportsImage?.fields?.file?.url
          }}"
        />
      </div>
      <div class="whitepapers-content">
        <div class="product-blog-subheading mar-b-16">White Paper</div>
        <div class="extensive-coverage-heading">
          {{ _whitePaperData.title }}
        </div>
        <div
          class="product-blog-description mar-b-48"
          [innerHtml]="_whitePaperData.whitepapersAndReportsContent | toHtml"
        ></div>
        <div>
          <a
            class="btn btn-full"
            [href]="`${path}${_whitePaperData.blogId}` | urlParams:queryParams"
            target="_blank"
            (click)="onWhitepaperCTAClick()"
            >Read More</a
          >
        </div>
      </div>
    </div>
  </div>
</section>
